import { render, staticRenderFns } from "./Objects.vue?vue&type=template&id=d4e6b2f0&scoped=true"
import script from "./Objects.js?vue&type=script&lang=js&external"
export * from "./Objects.js?vue&type=script&lang=js&external"
import style0 from "./Objects.scss?vue&type=style&index=0&id=d4e6b2f0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4e6b2f0",
  null
  
)

export default component.exports